<template>
    <div class="hello">
        <h1>{{ msg }}</h1>
        <h2>Essential Links</h2>
        <h2>Ecosystem</h2>
        <p>lang:{{ lang }}</p>
        <p>version:{{ version }}</p>
    </div>
</template>

<script>
export default {
    name: "HelloWorld",
    data() {
        return {
            lang: "", // 语言
            version: "", // 版本
            msg: "Welcome to Your Vue.js App"
        };
    },
    methods: {
        getUrlParam(name) {
            let query = window.location.search.substring(1);
            // console.log(query)
            let param_arr = query.split("&");
            for (let i = 0; i < param_arr.length; i++) {
                let pair = param_arr[i].split("=");
                if (pair[0] == name) {
                    return pair[1];
                }
            }
            return "null";
        }
    },
    created() {
        // console.log(window.location)
        let pathname = window.location.href;
        this.lang = this.getUrlParam("lang"); // 1
        this.version = this.getUrlParam("version"); // 1

        let { lang, version } = this;
        let _msg =
            "url：" +
            pathname +
            "  </br>语言：" +
            lang +
            "  </br>version：" +
            version;
        // console.log(_msg)
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
    font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue